module.exports = __webpack_public_path__ + "static/media/cover-mobile-411x93@2x.4361a80d.webp";